import { render, staticRenderFns } from "./NtagLocations.vue?vue&type=template&id=3bce4ecf&scoped=true&"
import script from "./NtagLocations.vue?vue&type=script&lang=ts&"
export * from "./NtagLocations.vue?vue&type=script&lang=ts&"
import style0 from "./NtagLocations.vue?vue&type=style&index=0&id=3bce4ecf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bce4ecf",
  null
  
)

export default component.exports